import { Payload } from "./types";

const onExperimentClick = () => {
  // eslint-disable-next-line no-alert
  window.alert("This is part of an experiment");
};

export const parseOption = (payload: Payload | undefined) =>
  payload && {
    ...payload,
    onClick: onExperimentClick,
    isExternalLink: false,
    linkText: payload?.label ?? "",
    qaLabel: payload?.qaLabel ?? "account-nav-option"
  };
